import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { mapStateToPropsWrapper, verificationProps } from '../CaptureErreurs';
import Card from '../Card';
import { afficherFichier } from '../../App_Code/API';

const CardCopro = ({ Nom, Img }) => (
    <Card Titre={CardCopro.titleName} SousTitre={Nom}>
        <p className="card-text mb-3">
            {Img && (
                <img
                    src={afficherFichier(Img)}
                    alt=""
                    className="rounded mx-auto d-block border border-secondary img-fluid img-logo"
                />
            )}
        </p>
        <Link to="/MaCopropriete" className="btn btn-outline-primary">
            Voir ma copropriété
        </Link>
    </Card>
);
CardCopro.displayName = 'CardCopro';
CardCopro.titleName = 'Ma copropriété';
CardCopro.requiredProps = [
    'Nom', // Nom du syndic
    'Img', // Logo du syndic
];

function mapStateToProps({
    CopStore: {
        Cop: {
            Ind: { Nom },
            Img,
        },
    },
}) {
    return { Nom, Img };
}

export default connect(mapStateToPropsWrapper(mapStateToProps))(verificationProps(CardCopro));



// WEBPACK FOOTER //
// ./src/components/Accueil/CardCopro.js